<div>
  @if (feedback && canWriteFeedback) {
    <div class="feedback-form-container">
      <form [formGroup]="form" [inert]="mode == 'show'">
        <div class="feedback-section">
          <h4 class="subheader">Allgemeine Informationen</h4>
          <div class="form-group">
            <p-floatLabel variant="on">
              <p-dropdown
                appendTo="body"
                [options]="courses"
                optionLabel="courseName"
                optionValue="courseId"
                id="courseId"
                formControlName="courseId"
                scrollHeight="400px"
              />
              <label for="gender">Kurs</label>
            </p-floatLabel>
            @if (isInvalid("courseId")) {
              <small class="p-error">Kurs erforderlich</small>
            }
          </div>
          <div class="form-group">
            <p-floatLabel variant="on">
              <p-dropdown
                [options]="allowedUsers"
                formControlName="creatorId"
                optionLabel="fullName"
                optionValue="userId"
                name="creatorId"
                id="creatorId"
                [filter]="true"
                filterBy="fullName"
                [showClear]="true"
                appendTo="body"
              ></p-dropdown
              ><label for="creatorId">Leitdozent</label></p-floatLabel
            >
          </div>
          <div>
            <div class="form-group small-calendar required-field">
              <p-floatLabel variante="on">
                <p-calendar
                  id="date"
                  formControlName="date"
                  name="date"
                  showIcon="true"
                  dateFormat="dd.mm.yy"
                  appendTo="body"
                ></p-calendar>
                <label for="date">Besuchstermin</label>
              </p-floatLabel>
              @if (isInvalid("date")) {
                <small class="p-error">Besuchstermin erforderlich</small>
              }
            </div>
          </div>

          @if (infoCategory) {
            <app-feedback-question-group
              [category]="infoCategory"
              [form]="form"
              [QUESTION_PREFIX]="QUESTION_PREFIX"
            />
          }
          <div>
            @if (selectedCourse) {
              <p>
                Termin APT1:
                <strong>{{
                  (selectedCourse.apt1Date | date: "dd.MM.yyyy") ?? "Unbekannt"
                }}</strong>
              </p>
              <p>
                Termin APT2:
                <strong>{{
                  (selectedCourse.apt2Date | date: "dd.MM.yyyy") ?? "Unbekannt"
                }}</strong>
              </p>
            }
          </div>
        </div>

        @for (category of otherCategories; track category.id) {
          <div class="feedback-section">
            <h4 class="subheader">{{ category.name }}</h4>
            <app-feedback-question-group
              [category]="category"
              [form]="form"
              [QUESTION_PREFIX]="QUESTION_PREFIX"
            />
          </div>
        }
        @if (mode != "show") {
          <button
            pButton
            size="small"
            type="button"
            [label]="
              mode == 'create'
                ? 'Feedback abschicken'
                : 'Feedback aktualisieren'
            "
            [icon]="isSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-save'"
            class="p-button-success"
            (click)="submitForm()"
          ></button>
        }
      </form>
    </div>
  }
</div>
